function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.028 4.853a.394.394 0 00.082.42l4.507 4.614a.37.37 0 00.532 0 .39.39 0 000-.544L1.282 5.385h8.109A.38.38 0 009.766 5a.38.38 0 00-.375-.385H1.282L5.149.657a.39.39 0 000-.544.37.37 0 00-.532 0L.11 4.728a.388.388 0 00-.082.125z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/arrow.64852e3f.svg";
export { SvgArrow as ReactComponent };